// extracted by mini-css-extract-plugin
module.exports = {"root":"Images45_root__2h0vZ","title":"Images45_title__1bXLm","images":"Images45_images__1_yYs"};